import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MappingCodeConfig  {
    _originalTypeClassName = "zERP.BO.MappingCodeConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MappingCodeConfig.translate = translateService;
}
this.CodeMaps = [];
this.SICProfessionPackages = [];
this.Id = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
CodeMaps:any;
SICProfessionPackages:any;
SpecialInsuranceCase:any;
static setCodeMaps = ($this, items) => {
                if (items == null) items = [];
                if ($this.CodeMaps == null) $this.CodeMaps = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CodeMaps.length > 0) {
                    Domain.MappingCodeConfig.removeCodeMaps($this, $this.CodeMaps[0]);
                }

                Domain.MappingCodeConfig.addManyCodeMaps($this, copyItems);
            }
static addManyCodeMaps = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MappingCodeConfig.addCodeMaps($this, items[i]);
                }
            }
static addCodeMaps = ($this, item) => {
                if ($this.CodeMaps == null) $this.CodeMaps = [];
                if (item == null || $this.CodeMaps.indexOf(item) > -1) return;
                $this.CodeMaps.push(item);
}
static addRangeCodeMaps = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MappingCodeConfig.addCodeMaps($this, item));
            }
static removeCodeMaps = ($this, item) => {
                if ($this == null || $this.CodeMaps == null || $this.CodeMaps.indexOf(item) === -1) return;
                var _index = $this.CodeMaps.indexOf(item);
                $this.CodeMaps.splice(_index, 1);
}
static clearCodeMaps = ($this) => { $this.CodeMaps = null; }
static setSICProfessionPackages = ($this, items) => {
                if (items == null) items = [];
                if ($this.SICProfessionPackages == null) $this.SICProfessionPackages = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SICProfessionPackages.length > 0) {
                    Domain.MappingCodeConfig.removeSICProfessionPackages($this, $this.SICProfessionPackages[0]);
                }

                Domain.MappingCodeConfig.addManySICProfessionPackages($this, copyItems);
            }
static addManySICProfessionPackages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MappingCodeConfig.addSICProfessionPackages($this, items[i]);
                }
            }
static addSICProfessionPackages = ($this, item) => {
                if ($this.SICProfessionPackages == null) $this.SICProfessionPackages = [];
                if (item == null || $this.SICProfessionPackages.indexOf(item) > -1) return;
                $this.SICProfessionPackages.push(item);
}
static addRangeSICProfessionPackages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MappingCodeConfig.addSICProfessionPackages($this, item));
            }
static removeSICProfessionPackages = ($this, item) => {
                if ($this == null || $this.SICProfessionPackages == null || $this.SICProfessionPackages.indexOf(item) === -1) return;
                var _index = $this.SICProfessionPackages.indexOf(item);
                $this.SICProfessionPackages.splice(_index, 1);
}
static clearSICProfessionPackages = ($this) => { $this.SICProfessionPackages = null; }
static setSpecialInsuranceCase = ($this, value) => {
var oldValue = $this.SpecialInsuranceCase;
$this.SpecialInsuranceCase = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}